import { ChangeEvent } from 'react';
import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { locateValue } from '@tool/index';

const moEffectTrend = observable({
  type: 'chart', // chart, table
  empty: false,
  staffCount: <number | string>'',
  tableTitle: <any[]>[],
  tableList: <any[]>[],
  arr: <any[]>[],
  maxStaff: 0,
  overview: <any[]>[],
  timer: <any>null,
});

const effectTrendInit = action(async (res: any) => {
  if (isEmpty(res) || isEmpty(res.chart_data)) {
    moEffectTrend.empty = true;
    return;
  }
  moEffectTrend.empty = false;
  let max = 0;
  const titles: any[] = [];
  const tableArr: any[] = [];

  // res.chart_data.map((item: any) => titles.push(item.category));
  res.chart_data.map((item: any) => {
    item.data.map((child: any) => {
      titles.push(`${child.label}年`);
    });
  });
  titles.unshift('职能');
  res.chart_data.map((item: any) => {
    item.data.map((child: any) => {
      if (child.count > max) max = child.count;
    });
  });
  res.chart_data.map((item: any) => {
    const tempArr: any[] = [];
    tempArr.push(item.category);
    item.data.map((child: any) => {
      if (child.count > 0) tempArr.push(`${locateValue(child.count)}人`);
      else tempArr.push('-');
    });
    tableArr.push(tempArr);
  });

  moEffectTrend.arr = res.chart_data;
  moEffectTrend.tableTitle = uniq(titles);
  moEffectTrend.maxStaff = max;
  moEffectTrend.overview = res.overview;
  moEffectTrend.tableList = tableArr;
});

const changeType = action((value: string) => {
  moEffectTrend.type = value;
  localStorage.setItem('effectTimeTrend', value);
});

const changeValue = action(async (ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
  const value = ev.target.value || '';
  const regRxp = /^[0-9]*$/;
  if (regRxp.test(value)) {
    moEffectTrend.staffCount = value;

    moEffectTrend.timer = setTimeout(() => {
      clearTimeout(moEffectTrend.timer);
      toggleValue('isLoading', true);
      EffectService.supportYearTrend({ staff_num: moEffectTrend.staffCount }).then((res: any) => {
        effectTrendInit(res);
        toggleValue('isLoading', false);
      });
    }, 500);
  }
});

const changeTrendStaff = action((val: number | string) => {
  moEffectTrend.staffCount = val;
});

export default moEffectTrend;
export {
  effectTrendInit, changeType, changeValue,
  changeTrendStaff,
};
